<template>
  <MainLayout class="hide-header-menu landing-main-v3" v-bind:attach-home="attachHome" v-bind:hide-app-header="true">
    <div class="landing-main-v3__container" slot="layout-body">
      <div class="landing-block-1">
        <div class="landing-block-1__logo">
          <img src="/static/images/ic-classting-logo.svg">
        </div>

        <div class="landing-block-1__title text-center">
          {{ $t('landing_v3.block1.title') }}
        </div>

        <div class="landing-block-1__subtitle text-center hidden-sm-down">
          {{ $t('landing_v3.block1.subtitle') }}
        </div>

        <div class="landing-block-1__subtitle text-center hidden-md-up" v-html="$t('landing_v3.block1.subtitle_mobile')">
        </div>

        <div class="landing-block-1__btn-row mx-auto">
          <div class="row">
            <div class="col-12 col-md-6">
              <button class="btn btn-primary btn-block btn-rectangle" v-on:click="startCl()">
                <span v-html="$t('landing_v3.block1.start_btn')"></span>
              </button>
            </div>

            <div class="col-12 col-md-6">
              <a
                class="btn btn-outline-primary btn-block btn-rectangle"
                :href="aiUrl"
                target="_blank"
              >
                {{ $t('landing_v3.block1.go_to_premium') }}
              </a>
            </div>
          </div>
        </div>

        <div class="landing-block-1__partner-list mx-auto">
          <img src="/static/images/img-cp-list-small@2x.png">
        </div>
      </div>

      <div class="landing-block-2">
        <div class="landing-block-2__title text-center typography--color-primary" v-html="$t('landing_v3.block2.title')">
        </div>

        <div class="landing-block-2__main-intro mx-auto">
          <div class="row">
            <div class="col align-self-center text-center hidden-sm-down">
              <img src="/static/images/img-main-before.svg" class="align-self-center landing-block-2__main-before">
            </div>

            <img src="/static/images/img-main-arrow-line.png" class="align-self-center landing-block-2__bg-arrow">

            <div class="col-md-7 landing-block-2__main-video text-center">

              <div class="landing-block-2__main-video__student-icon">
                <img src="/static/images/ic-student-m.svg">
              </div>

              <video autoplay loop>
                <track kind="captions">
                <source src="/static/videos/main_intro_v3.mp4" type="video/mp4">
              </video>
            </div>

            <div class="col align-self-center text-center hidden-sm-down">
              <img src="/static/images/img-main-after.svg" class="landing-block-2__main-after">
            </div>
          </div>
        </div>
      </div>

      <div class="landing-block-3">
        <div class="landing-block-3__guide-arrow text-center">
          <img src="/static/images/ic-arrow-intro.svg">
        </div>

        <div class="landing-block-3__title text-center typography--color-primary">
          <img src="/static/images/img-cl-logo-intro.svg" alt="Classting Learning">
          {{ $t('landing_v3.block3.title') }}
        </div>

        <div class="landing-block-3__guide-number text-center">
          01
        </div>

        <div class="landing-block-3__feature-intro mx-auto">
          <div class="row">
            <div class="col-12 col-md-5 push-md-7 landing-block-3__feature-intro__text">
              <div class="landing-block-3__feature-intro__title typography--color-primary">
                {{ $t('landing_v3.block3.features.01.title') }}
              </div>

              <div class="landing-block-3__feature-intro__description typography--color-secondary" v-html="$t('landing_v3.block3.features.01.description')">
              </div>
            </div>

            <div class="col-12 col-md-7 pull-md-5 landing-block-3__feature-intro__video">
              <video autoplay loop>
                <track kind="captions">
                <source src="/static/videos/assign_easily_v3.mp4" type="video/mp4">
              </video>
            </div>
          </div>
        </div>

        <div class="landing-block-3__guide-number text-center">
          02
        </div>

        <div class="landing-block-3__feature-intro mx-auto">
          <div class="row">
            <div class="col-12 col-md-5 landing-block-3__feature-intro__text">
              <div class="landing-block-3__feature-intro__text-right">
                <div class="landing-block-3__feature-intro__title typography--color-primary">
                  {{ $t('landing_v3.block3.features.02.title') }}
                </div>

                <div class="landing-block-3__feature-intro__description typography--color-secondary" v-html="$t('landing_v3.block3.features.02.description')">
                </div>
              </div>
            </div>

            <div class="col-12 col-md-7 landing-block-3__feature-intro__video">
              <video autoplay loop>
                <track kind="captions">
                <source src="/static/videos/learning_reports_v3.mp4" type="video/mp4">
              </video>
            </div>
          </div>
        </div>

      </div>

      <div class="landing-block-5">
        <carousel v-bind:per-page="1"
                  pagination-active-color="#00c896"
                  pagination-color="rgba(0, 0, 0, 0.1)"
                  v-bind:pagination-padding="6"
                  v-bind:pagination-size="10"
                  v-bind:loop="true"
                  v-bind:autoplay-hover-pause="true"
                  v-bind:autoplay-timeout="3000"
                  v-bind:autoplay="false">
          <slide v-for="item in selectedAnalysisSlides" v-bind:key="item.id">
            <div class="row">
              <div class="col-12 col-md-6 landing-block-5__slide-image">
                <img v-bind:src="item.image" class="img-fluid">
              </div>

              <div class="col-12 col-md-6 align-self-center landing-block-5__slide-text">
                <div class="landing-block-5__title typography--color-primary typography--font-weight-500">
                  {{ $t(item.title) }}
                </div>

                <div class="landing-block-5__description typography--color-secondary" v-html="$t(item.subtitle)">
                </div>
              </div>
            </div>
          </slide>
        </carousel>
      </div>

      <div class="landing-block-6">
        <div class="landing-block-6__title typography--color-primary text-center">
          {{ $t('landing_v3.block6.title') }}
        </div>

        <div class="landing-block-6__subtitle typography--color-secondary text-center mx-auto" v-html="$t('landing_v3.block6.subtitle')">
        </div>

        <div class="landing-block-6__stats mx-auto">
          <div class="row">
            <div class="col-12 col-md-4 text-center">
              <div class="landing-block-6__stats__icon">
                <img src="/static/images/ic-total-user.svg">
              </div>

              <div class="landing-block-6__stats__number">
                {{ $t('landing_v3.block6.stats.users.count') }}
              </div>

              <div class="landing-block-6__stats__label typography--color-secondary typography--font-weight-500">
                {{ $t('landing_v3.block6.stats.users.label') }}
              </div>
            </div>

            <div class="col-12 col-md-4 text-center">
              <div class="landing-block-6__stats__icon">
                <img src="/static/images/ic-total-teacher.svg">
              </div>

              <div class="landing-block-6__stats__number">
                {{ $t('landing_v3.block6.stats.teachers.count') }}
              </div>

              <div class="landing-block-6__stats__label typography--color-secondary typography--font-weight-500">
                {{ $t('landing_v3.block6.stats.teachers.label') }}
              </div>
            </div>

            <div class="col-12 col-md-4 text-center">
              <div class="landing-block-6__stats__icon">
                <img src="/static/images/ic-total-school.svg">
              </div>

              <div class="landing-block-6__stats__number">
                {{ $t('landing_v3.block6.stats.schools.count') }}
              </div>

              <div class="landing-block-6__stats__label typography--color-secondary typography--font-weight-500">
                {{ $t('landing_v3.block6.stats.schools.label') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="landing-block-7">
        <div class="landing-block-7__title text-center">
          {{ $t('landing_v3.block7.title') }}
        </div>

        <div class="landing-block-7__subtitle text-center mx-auto">
          {{ $t('landing_v3.block7.subtitle') }}
        </div>

        <div class="landing-block-7__btn-row mx-auto">
          <div class="row">
            <div class="col-12 col-md-6">
              <button class="btn btn-primary btn-block btn-rectangle" v-on:click="startCl()">
                <span v-html="$t('landing_v3.block7.start_btn')"></span>
              </button>
            </div>

            <div class="col-12 col-md-6">
              <router-link
                to="/inquiries"
                tag="button"
                class="btn btn-outline-primary btn-block btn-rectangle"
                v-html="$t('landing_v3.block7.inquiry_btn')"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="landing-block-8">
        <div class="landing-block-8__testimonials hidden-sm-down">
          <div class="row no-gutters teachers-top-row">
            <div class="col teachers-side-col">
              <div class="row no-gutters">
                <div class="col col-md-6 teachers-img-col">
                  <div>
                    <div class="transparent-bg"></div>
                    <img src="/static/images/left-1-1.jpg" class="w-100 img-fluid">
                  </div>
                  <div>
                    <div class="transparent-bg"></div>
                    <img src="/static/images/left-2-1.jpg" class="w-100 img-fluid">
                  </div>
                </div>

                <div class="col col-md-6 teachers-img-col">
                  <div>
                    <div class="transparent-bg"></div>
                    <img src="/static/images/left-1-2.jpg" class="w-100 img-fluid">
                  </div>
                  <div>
                    <div class="transparent-bg"></div>
                    <img src="/static/images/left-2-2.jpg" class="w-100 img-fluid">
                  </div>
                </div>
              </div>
            </div>

            <div class="col teachers-middle-col">
              <div class="landing-block-8__video-cover">
                <div class="landing-block-8__video-cover__title text-center" v-html="$t('landing_v3.block8.video_title')">
                </div>

                <div class="text-center">
                  <button class="landing-block-8__video-cover__btn clickable" v-on:click="showVideo = true">
                    <img src="/static/images/ic-play-btn.svg" alt="play teacher interview video">
                  </button>
                </div>
              </div>

              <button class="landing-block-8__close-video-btn clickable"
                      v-on:click="showVideo = false"
                      v-if="showVideo">
                <img src="/static/images/icon-cancel.svg">
              </button>

              <div class="landing-block-8__video-container" v-if="showVideo">
                <iframe
                  frameborder="0"
                  width="560"
                  height="315"
                  id="video"
                  src="https://www.youtube.com/embed/FJNviT9gJss?autoplay=1;rel=0&showinfo=0"
                  allowfullscreen
                />
              </div>
            </div>

            <div class="col teachers-side-col">
              <div class="row no-gutters">
                <div class="col col-md-6 teachers-img-col">
                  <div>
                    <div class="transparent-bg"></div>
                    <img src="/static/images/right-1-1.jpg" class="w-100 img-fluid">
                  </div>
                  <div>
                    <div class="transparent-bg"></div>
                    <img src="/static/images/right-2-1.jpg" class="w-100 img-fluid">
                  </div>
                </div>

                <div class="col col-md-6 teachers-img-col">
                  <div>
                    <div class="transparent-bg"></div>
                    <img src="/static/images/right-1-2.jpg" class="w-100 img-fluid">
                  </div>
                  <div>
                    <div class="transparent-bg"></div>
                    <img src="/static/images/right-2-2.jpg" class="w-100 img-fluid">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row no-gutters teachers-bottom-row">
            <div class="col teachers-img-col">
              <div class="transparent-bg"></div>
              <img src="/static/images/bottom-1-1.jpg" class="w-100 img-fluid">
            </div>

            <div class="col teachers-img-col">
              <div class="transparent-bg"></div>
              <img src="/static/images/bottom-1-2.jpg" class="w-100 img-fluid">
            </div>

            <div class="col teachers-img-col">
              <div class="transparent-bg"></div>
              <img src="/static/images/bottom-1-3.jpg" class="w-100 img-fluid">
            </div>

            <div class="col teachers-img-col">
              <div class="transparent-bg"></div>
              <img src="/static/images/bottom-1-4.jpg" class="w-100 img-fluid">
            </div>

            <div class="col teachers-img-col">
              <div class="transparent-bg"></div>
              <img src="/static/images/bottom-1-5.jpg" class="w-100 img-fluid">
            </div>

            <div class="col teachers-img-col">
              <div class="transparent-bg"></div>
              <img src="/static/images/bottom-1-6.jpg" class="w-100 img-fluid">
            </div>

            <div class="col teachers-img-col">
              <div class="transparent-bg"></div>
              <img src="/static/images/bottom-1-7.jpg" class="w-100 img-fluid">
            </div>

            <div class="col teachers-img-col">
              <div class="transparent-bg"></div>
              <img src="/static/images/bottom-1-8.jpg" class="w-100 img-fluid">
            </div>

            <div class="col teachers-img-col">
              <div class="transparent-bg"></div>
              <img src="/static/images/bottom-1-9.jpg" class="w-100 img-fluid">
            </div>
          </div>
        </div>

        <div class="landing-block-8__testimonials-mobile hidden-md-up">
          <div class="landing-block-8__video-cover">
            <div class="landing-block-8__video-cover__title text-center" v-html="$t('landing_v3.block8.video_title')">
            </div>

            <div class="text-center">
              <button class="landing-block-8__video-cover__btn clickable" v-on:click="showVideo = true">
                <img src="/static/images/ic-play-btn.svg" alt="play teacher interview video">
              </button>
            </div>
          </div>

          <button class="landing-block-8__close-video-btn clickable"
                  v-on:click="showVideo = false"
                  v-if="showVideo">
            <img src="/static/images/icon-cancel.svg">
          </button>

          <div class="landing-block-8__video-container" v-if="showVideo">
            <iframe
              frameborder="0"
              width="560"
              height="315"
              id="video-mobile"
              src="https://www.youtube.com/embed/FJNviT9gJss?autoplay=1;rel=0&showinfo=0"
              allowfullscreen
            />
          </div>
        </div>

        <div class="landing-block-8__edulab-photos-mobile hidden-md-up">
          <img src="/static/images/bg-edulab-768.jpg" class="w-100">
        </div>
      </div>

      <div class="landing-block-9">
        <div class="text-center">
          <FooterContent></FooterContent>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { CLASSTING_FULL_AUTH_URL, AI_WEB_URL } from '@/config';

  export default {
    name: 'landing-main-v3',

    props: {
      isIntro: {
        type: Boolean,
        default: false,
      },
      attachHome: {
        type: Boolean,
        default: true,
      },
    },

    data() {
      return {
        aiUrl: AI_WEB_URL,
        authUrl: CLASSTING_FULL_AUTH_URL,
        selectedAnalysisView: 'teacher',
        analysisSlides: {
          teacher: [{
            id: 'teacher_01',
            image: '/static/images/teacher_analysis_02_1.png',
            title: 'landing_v2.block7.teacher.slide1.title',
            subtitle: 'landing_v2.block7.teacher.slide1.subtitle',
          }, {
            id: 'teacher_02',
            image: '/static/images/teacher_analysis_02_2.png',
            title: 'landing_v2.block7.teacher.slide2.title',
            subtitle: 'landing_v2.block7.teacher.slide2.subtitle',
          }],
          student: [{
            id: 'student_01',
            image: '/static/images/student_analysis_02_1.png',
            title: 'landing_v2.block7.student.slide1.title',
            subtitle: 'landing_v2.block7.student.slide1.subtitle',
          }, {
            id: 'student_02',
            image: '/static/images/student_analysis_02_2.png',
            title: 'landing_v2.block7.student.slide2.title',
            subtitle: 'landing_v2.block7.student.slide2.subtitle',
          }],
          parent: [{
            id: 'parent_01',
            image: '/static/images/parent_analysis_02_1.png',
            title: 'landing_v2.block7.parent.slide1.title',
            subtitle: 'landing_v2.block7.parent.slide1.subtitle',
          }, {
            id: 'parent_02',
            image: '/static/images/parent_analysis_02_2.png',
            title: 'landing_v2.block7.parent.slide2.title',
            subtitle: 'landing_v2.block7.parent.slide2.subtitle',
          }],
        },
        showVideo: false,
      };
    },

    computed: {
      ...mapGetters([
        'isSignedIn',
      ]),

      selectedAnalysisSlides() {
        return this.analysisSlides[this.selectedAnalysisView];
      },
    },

    methods: {
      startCl() {
        if (this.isIntro) {
          return this.$router.push('/library');
        }

        if (this.isSignedIn) {
          return this.$router.push('/library');
        }

        sessionStorage.setItem('continue_url', '/library');
        window.location.href = this.authUrl;
        return true;
      },
    },
  };
</script>

<style lang="scss">
  .landing-main-v3 {
    .scroll-app-header {
      @media (min-width: 1312px) {
        padding-left: 0;
      }
    }

    .app-header-container {
      width: 100%;
    }

    .layout-body {
      padding-top: 0 !important;
    }

    .action-bar {
      border-bottom: none !important;
    }

    .landing-block-1 {
      padding-bottom: 22px;
      background-image: url('/static/images/img-landing-main-v3.jpg');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }

    .landing-block-1__logo {
      padding: 16px;

      @media (min-width: 768px) {
        padding: 9px 12px;
      }

      @media (min-width: 992px) {
        padding: 15px 20px;
      }

      .logo_image {
        width: 126px;

        @media (min-width: 768px) {
          width: 80px;
        }

        @media (min-width: 992px) {
          width: 126px;
        }
      }
    }

    .landing-block-1__title {
      font-size: 32px;
      font-weight: 600;
      letter-spacing: -0.5px;
      line-height: 39px;
      color: #fff;
      margin-top: 90px;

      @media (min-width: 768px) {
        line-height: 43px;
        margin-top: 85px;
      }

      @media (min-width: 992px) {
        font-size: 58px;
        letter-spacing: -1px;
        line-height: 69px;
        margin-top: 139px;
      }
    }

    .landing-block-1__subtitle {
      font-size: 16px;
      line-height: 1.38;
      letter-spacing: -1px;
      line-height: 22px;
      color: rgba(255, 255, 255, 0.7);
      margin-top: 10px;

      @media (min-width: 768px) {
        font-size: 14px;
        line-height: 1.33;
        letter-spacing: -0.5px;
        line-height: 19px;
        margin-top: 12px;
      }

      @media (min-width: 992px) {
        font-size: 24px;
        line-height: 1.25;
        letter-spacing: -1.1px;
        line-height: 30px;
        margin-top: 20px;
      }
    }

    .landing-block-1__btn-row {
      padding-left: 22px;
      padding-right: 22px;
      margin-top: 75px;

      @media (min-width: 768px) {
        margin-top: 28px;
        max-width: 424px;
      }

      @media (min-width: 992px) {
        margin-top: 48px;
        max-width: 544px;
      }

      .btn-block {
        font-size: 14px;
        font-weight: 500;
        line-height: 14px;
        padding-top: 16px;
        padding-bottom: 16px;
        margin-top: 12px;

        @media (min-width: 768px) {
          font-size: 12px;
          padding-top: 9px;
          padding-bottom: 9px;
        }

        @media (min-width: 992px) {
          font-size: 16px;
          line-height: 18px;
          padding-top: 13px;
          padding-bottom: 13px;
        }
      }

      .btn-outline-primary {
        color: #00c896;
        border-color: #00c896;

        &:hover,
        &:focus:hover,
        &.active {
          border-color: #00b68f;
          color: #00b68f;
        }

        &:active,
        &:focus:active {
          border-color: #009a87;
          color: #009a87;
        }
      }
    }

    .landing-block-1__partner-list {
      display: none;

      @media (min-width: 768px) {
        display: block;
        max-width: 600px;
        margin-top: 67px;
        padding-bottom: 8px;
      }

      @media (min-width: 992px) {
        max-width: 950px;
        margin-top: 130px;
        padding-bottom: 20px;
      }

      img {
        width: 100%;
      }
    }

    .landing-block-2 {
      position: relative;
      z-index: 1;
      padding-top: 34px;
      padding-left: 20px;
      padding-right: 20px;
      background-color: #fff;
      background-image: url('/static/images/bg-main-graph.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      @media (min-width: 768px) {
        font-size: 22px;
        padding-top: 44px;
        background-image: url('/static/images/bg-gray-2.svg');
      }

      @media (min-width: 992px) {
        font-size: 36px;
        letter-spacing: -0.9px;
        padding-top: 70px;
      }
    }

    .landing-block-2__title {
      font-size: 18px;
      font-weight: 300;
      letter-spacing: -0.5px;
      line-height: 21px;

      @media (min-width: 768px) {
        font-size: 22px;
        line-height: 27px;
      }

      @media (min-width: 992px) {
        font-size: 36px;
        line-height: 43px;
        letter-spacing: -0.9px;
      }
    }

    .landing-block-2__main-intro {
      max-width: 1380px;
      margin-top: 13px;
      position: relative;

      @media (min-width: 768px) {
        margin-top: 36px;
      }

      @media (min-width: 992px) {
        margin-top: 60px;
      }
    }

    .landing-block-2__main-before {
      @media (max-width: 991px) {
        max-width: 49.5px;
      }
    }

    .landing-block-2__main-after {
      @media (max-width: 991px) {
        max-width: 90.3px;
      }
    }

    .landing-block-2__bg-arrow {
      display: none;

      @media (min-width: 768px) {
        display: block;
        position: absolute;
        left: 15%;
        width: 69%;
        z-index: 1;
      }

      @media (min-width: 992px) {
        width: 67%;
      }

      @media (min-width: 1200px) {
        width: 68%;
      }

      @media (min-width: 1400px) {
        width: 69%;
      }
    }

    .landing-block-2__main-video {
      position: relative;
      z-index: 1;

      video {
        width: 100%;
        border-radius: 4px;
        margin-bottom: -20px;
        object-fit: contain;
        box-shadow: 0 1px 14px 0 rgba(0, 0, 0, 0.3);
        display: inline-block;
        position: relative;
      }
    }

    .landing-block-2__main-video__student-icon {
      display: inline-block;
      position: relative;
      margin-bottom: -28px;
      z-index: 999;

      @media (min-width: 768px) {
        display: none;
      }
    }

    .landing-block-3 {
      background-image: linear-gradient(to bottom, #ffffff, #f7f7f7);
      position: relative;
      z-index: 999;
      padding-top: 36px;
      padding-bottom: 28px;
      box-shadow: rgba(0, 0, 0, 0.5) 0px -1px 5px;

      @media (min-width: 768px) {
        padding-top: 24px;
        padding-bottom: 33px;
      }

      @media (min-width: 992px) {
        padding-top: 40px;
        padding-bottom: 71px;
      }

      @media (min-width: 1300px) {
        padding-bottom: 82px;
      }
    }

    .landing-block-3__guide-arrow img {
      @media (min-width: 768px) and (max-width: 991px) {
        width: 12.4px;
      }
    }

    .landing-block-3__title {
      font-size: 18px;
      font-weight: 200;
      line-height: 21px;
      letter-spacing: -0.5px;
      margin-top: 20px;

      img {
        width: 92.5px;
      }

      @media (min-width: 768px) {
        font-size: 22px;
        line-height: 27px;
        letter-spacing: -0.6px;
        margin-top: 25.4px;

        img {
          width: 114.4px;
        }
      }

      @media (min-width: 992px) {
        font-size: 36px;
        line-height: 43px;
        letter-spacing: -0.9px;
        margin-top: 40px;

        img {
          width: initial;
        }
      }
    }

    .landing-block-3__guide-number {
      font-size: 30px;
      font-weight: 300;
      color: #f8756c;
      line-height: 30px;
      margin-top: 44px;

      @media (min-width: 768px) {
        font-size: 32px;
        margin-top: 32.2px;
      }

      @media (min-width: 992px) {
        font-size: 52px;
        line-height: 50px;
        margin-top: 76px;
      }
    }

    .landing-block-3__feature-intro {
      margin-top: 2px;

      @media (min-width: 768px) {
        margin-top: 30px;
      }

      @media (min-width: 992px) {
        margin-top: 60px;
      }

      .row {
        margin-left: 0 !important;
        margin-right: 0 !important;
      }
    }

    .landing-block-3__feature-intro__text {
      padding-top: 18px;
      padding-left: 0 !important;
      padding-right: 0 !important;
      text-align: center;

      @media (min-width: 768px) {
        padding-top: 25px;
        padding-left: 30px !important;
        text-align: left;
      }

      @media (min-width: 992px) {
        padding-top: 40px;
        padding-left: 40px !important;
      }

      @media (min-width: 1400px) {
        padding-top: 70px;
        padding-left: 56px !important;
      }
    }

    .landing-block-3__feature-intro__text-right {
      @media (min-width: 768px) {
        float: right;
        max-width: 302px;
        padding-right: 30px;
      }

      @media (min-width: 992px) {
        max-width: 480px;
        padding-right: 40px;
      }

      @media (min-width: 1400px) {
        max-width: 560px;
        padding-right: 56px;
      }
    }

    .landing-block-3__feature-intro__title {
      font-size: 24px;
      line-height: 24px;

      @media (min-width: 768px) {
        line-height: 22px;
      }

      @media (min-width: 992px) {
        font-size: 40px;
        line-height: 36px;
      }

      @media (min-width: 1400px) {
        font-size: 46px;
        line-height: 50px;
        letter-spacing: -1px;
      }
    }

    .landing-block-3__feature-intro__description {
      font-size: 14px;
      line-height: 19px;
      letter-spacing: -0.7px;
      margin-top: 14px;
      padding-bottom: 20px;

      @media (min-width: 768px) {
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -0.6px;
      }

      @media (min-width: 992px) {
        font-size: 16px;
        line-height: 26px;
        letter-spacing: -0.8px;
        margin-top: 20px;
      }

      @media (min-width: 1400px) {
        font-size: 20px;
        line-height: 29px;
        letter-spacing: -1px;
      }
    }

    .landing-block-3__feature-intro__video {
      padding-bottom: 12px;
      padding-left: 0 !important;
      padding-right: 0 !important;

      @media (min-width: 768px) {
        padding-bottom: 8.8px;
      }

      @media (min-width: 992px) {
        padding-bottom: 8px;
      }

      @media (min-width: 1300px) {
        padding-bottom: 47px;
      }

      video {
        width: 100%;
        object-fit: contain;
        border-radius: 4px;
        box-shadow: 0 1px 14px 0 rgba(0, 0, 0, 0.3);
        display: inline-block;
        position: relative;
        margin-bottom: -7px;
      }
    }

    .landing-block-3__link-btn {
      margin-top: 16px;

      @media (min-width: 768px) {
        margin-top: 46px;
      }

      @media (min-width: 992px) {
        margin-top: 40px;
      }

      .btn-primary {
        font-size: 16px;
        line-height: 24px;
        letter-spacing: -0.9px;
        padding-top: 8px;
        padding-bottom: 8px;
        min-width: 200px;

        @media (min-width: 768px) and (max-width: 991px) {
          font-size: 12px;
          line-height: 20px;
          letter-spacing: -1px;
          padding-top: 6px;
          padding-bottom: 6px;
          min-width: 130px;

          img {
            height: 13.1px;
          }
        }

        @media (min-width: 992px) {
          min-width: 160px;
        }

        span {
          vertical-align: text-top;
          margin-right: 8px;
          font-weight: 500;
        }
      }
    }

    .landing-block-4 {
      padding-top: 30px;
      background-color: #fff;
      position: relative;
      z-index: 9999;

      @media (min-width: 992px) {
        padding-top: 64px;
      }
    }

    .landing-block-4__tabs {
      padding-left: 10px;
      padding-right: 10px;

      @media (min-width: 768px) {
        max-width: 472px;
      }

      @media (min-width: 992px) {
        max-width: 778px;
      }
    }

    .landing-block-4__icon-img>img {
      width: 40px;

      @media (min-width: 768px) {
        width: 49.5px;
      }

      @media (min-width: 992px) {
        width: 80px;
      }
    }

    .landing-block-4__icon-desc {
      display: inline-block;
      font-size: 12px;
      line-height: 15px;
      margin-top: 12px;
      width: 90px;
      color: rgba(0, 0, 0, 0.54);

      @media (min-width: 768px) {
        line-height: 12px;
        margin-top: 16.5px;
        width: 100%;
      }

      @media (min-width: 992px) {
        font-size: 16px;
        line-height: 20px;
        margin-top: 30px;
      }
    }

    .landing-block-4__active-bar-box {
      margin-top: 10px;
      line-height: 4px;
      height: 4px;

      @media (min-width: 768px) {
        margin-top: 17px;
        line-height: 5px;
        height: 5px;
      }

      @media (min-width: 992px) {
        margin-top: 25px;
      }
    }

    .landing-block-4__active-bar {
      height: 4px;
      width: 100%;
      background-color: #00c896;

      @media (min-width: 768px) {
        display: inline-block;
        max-width: 130px;
        height: 5px;
        vertical-align: bottom;
      }

      @media (min-width: 992px) {
        max-width: 200px;
      }
    }

    .landing-block-5 {
      padding-bottom: 29px;

      .VueCarousel>.VueCarousel-pagination .VueCarousel-dot {
        margin-top: 0 !important;
      }
    }

    .landing-block-5__slide-image {
      text-align: center;

      @media (min-width: 768px) {
        text-align: right;
      }
    }

    .landing-block-5__slide-text {
      text-align: center;

      @media (min-width: 768px) {
        text-align: left;
      }
    }

    .landing-block-5__title {
      font-size: 16px;
      line-height: 17.5px;
      letter-spacing: -0.7px;

      @media (min-width: 768px) {
        line-height: 21px;
        letter-spacing: -1px;
      }

      @media (min-width: 992px) {
        font-size: 20px;
        line-height: 35px;
        letter-spacing: -1px;
        padding-left: 24px;
      }
    }

    .landing-block-5__description {
      font-size: 14px;
      line-height: 19px;
      margin-top: 12.5px;

      @media (min-width: 768px) {
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -1px;
        margin-top: 8px;
      }

      @media (min-width: 992px) {
        font-size: 14px;
        line-height: 21px;
        margin-top: 17px;
        padding-left: 24px;
      }
    }

    .landing-block-6 {
      padding-top: 40px;
      padding-bottom: 40px;
      background-color: #fff;

      @media (min-width: 768px) {
        padding-top: 44.3px;
      }

      @media (min-width: 992px) {
        padding-top: 73px;
        padding-bottom: 74px;
      }
    }

    .landing-block-6__title {
      font-size: 18px;
      line-height: 18px;
      letter-spacing: -0.4px;

      @media (min-width: 768px) {
        font-size: 22px;
        line-height: 22px;
        letter-spacing: -0.5px;
      }

      @media (min-width: 992px) {
        font-size: 36px;
        line-height: 36px;
        letter-spacing: -0.9px;
      }
    }

    .landing-block-6__subtitle {
      font-size: 14px;
      line-height: 19px;
      margin-top: 14px;
      width: 316px;

      @media (min-width: 768px) {
        font-size: 12px;
        line-height: 16px;
        margin-top: 13px;
        width: 100%;
      }

      @media (min-width: 992px) {
        font-size: 18px;
        line-height: 24px;
        margin-top: 22px;
      }
    }

    .landing-block-6__stats {
      padding-left: 10px;
      padding-right: 10px;

      @media (min-width: 768px) {
        max-width: 622px;
      }

      @media (min-width: 992px) {
        max-width: 1000px;
      }
    }

    .landing-block-6__stats__icon {
      margin-top: 40px;

      @media (min-width: 768px) {
        margin-top: 51.7px;

        img {
          width: 80px;
        }
      }

      @media (min-width: 992px) {
        margin-top: 66px;

        img {
          width: 120px;
        }
      }
    }

    .landing-block-6__stats__number {
      font-size: 42px;
      font-weight: 300;
      line-height: 35px;
      color: #00c896;
      margin-top: 17px;

      @media (min-width: 768px) {
        font-size: 30px;
        line-height: 24px;
        margin-top: 11.3px;
      }

      @media (min-width: 992px) {
        font-size: 42px;
        line-height: 35px;
        margin-top: 17px;
      }
    }

    .landing-block-6__stats__label {
      font-size: 14px;
      line-height: 21px;
      margin-top: 10px;

      @media (min-width: 768px) {
        font-size: 12px;
        line-height: 15px;
        margin-top: 7px;
      }

      @media (min-width: 992px) {
        font-size: 14px;
        line-height: 21px;
        margin-top: 10px;
      }
    }

    .landing-block-7 {
      padding-top: 36px;
      padding-bottom: 36px;
      background-color: #2c3540;

      @media (min-width: 768px) {
        padding-top: 49px;
        padding-bottom: 64px;
      }

      @media (min-width: 992px) {
        padding-top: 80px;
        padding-bottom: 118px;
      }
    }

    .landing-block-7__title {
      font-size: 18px;
      line-height: 18px;
      letter-spacing: -0.4px;
      color: rgba(255, 255, 255, 0.87);

      @media (min-width: 768px) {
        font-size: 22px;
        line-height: 22.3px;
        letter-spacing: -0.5px;
      }

      @media (min-width: 992px) {
        font-size: 36px;
        line-height: 36px;
        letter-spacing: -0.9px;
      }
    }

    .landing-block-7__subtitle {
      font-size: 14px;
      line-height: 17px;
      color: rgba(255, 255, 255, 0.54);
      margin-top: 12px;
      width: 270px;

      @media (min-width: 768px) {
        font-size: 12px;
        line-height: 14px;
        margin-top: 13.2px;
        width: 100%;
      }

      @media (min-width: 992px) {
        font-size: 18px;
        line-height: 22px;
        margin-top: 22px;
      }
    }

    .landing-block-7__btn-row {
      padding-left: 22px;
      padding-right: 22px;
      margin-top: 28px;

      @media (min-width: 768px) {
        margin-top: 26.5px;
        max-width: 424px;
      }

      @media (min-width: 992px) {
        margin-top: 40px;
        max-width: 544px;
      }

      .btn-block {
        font-size: 14px;
        font-weight: 500;
        line-height: 14px;
        padding-top: 16px;
        padding-bottom: 16px;
        margin-top: 12px;

        @media (min-width: 768px) {
          font-size: 12px;
          padding-top: 9px;
          padding-bottom: 9px;
        }

        @media (min-width: 992px) {
          font-size: 16px;
          line-height: 18px;
          padding-top: 13px;
          padding-bottom: 13px;
        }
      }

      .btn-outline-primary {
        color: #00c896;
        border-color: #00c896;

        &:hover,
        &:focus:hover,
        &.active {
          border-color: #00b68f;
          color: #00b68f;
        }

        &:active,
        &:focus:active {
          border-color: #009a87;
          color: #009a87;
        }
      }
    }

    .landing-block-8 {
      background-color: #2c3540;

      .transparent-bg {
        background: rgba(0,0,0,0.4);
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
      }

      .teachers-top-row {
        .teachers-side-col {
          align-self: flex-end;
          width: 22.222%;
          flex: 0 0 22.222%;

          @media (max-width: 767px) {
            width: 11.111%;
            flex: 0 0 11.111%;
          }
        }

        .teachers-middle-col {
          position: relative;
          align-self: flex-end;
          width: 55.556%;
          flex: 0 0 55.556%;

          @media (max-width: 767px) {
            width: 77.778%;
            flex: 0 0 77.778%;
          }

          .vjs_video_3-dimensions {
            @media (max-width: 991px) {
              height: 310px;
            }

            @media (max-width: 459px) {
              height: 180px;
            }
          }
        }
      }

      .teachers-bottom-row {
        .teachers-img-col {
          width: 11.111%;
          flex: 0 0 11.111%;
        }
      }
    }

    .landing-block-8__video-cover {
      padding-top: 48px;
      padding-bottom: 48.5px;
      background-image: url('/static/images/img-video-thumbnail-1280.jpg');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      @media (min-width: 576px) {
        padding-top: 97px;
        padding-bottom: 100px;
      }

      @media (min-width: 768px) {
        padding-top: 60px;
        padding-bottom: 59.1px;
      }

      @media (min-width: 992px) {
        padding-top: 97px;
        padding-bottom: 100px;
      }

      @media (min-width: 1280px) {
        background-image: url('/static/images/img-video-thumbnail-1920.jpg');
      }

      @media (min-width: 1500px) {
        padding-top: 167px;
        padding-bottom: 183px;
      }
    }

    .landing-block-8__video-cover__title {
      font-size: 14px;
      font-weight: 200;
      line-height: 16.666667px;
      letter-spacing: -0.5px;
      color: rgba(255, 255, 255, 0.87);

      @media (min-width: 768px) {
        font-size: 18px;
        line-height: 20.333336px;
        letter-spacing: -0.7px;
      }

      @media (min-width: 992px) {
        font-size: 28px;
        line-height: 34px;
        letter-spacing: -1px;
      }

      @media (min-width: 1400px) {
        font-size: 32px;
        line-height: 40px;
      }

      strong {
        font-weight: bold;
      }
    }

    .landing-block-8__video-cover__btn {
      background-color: transparent;
      padding: 0;
      border: none;
      margin-top: 14.5px;

      @media (min-width: 992px) {
        margin-top: 23px;
      }

      img {
        width: 29px;

        @media (min-width: 768px) {
          width: 34.6px;
        }

        @media (min-width: 992px) {
          width: 54px;
        }

        @media (min-width: 1400px) {
          width: 80px;
        }
      }
    }

    .landing-block-8__close-video-btn {
      position: absolute;
      top: -2em;
      right: -2em;
      height: 25px;
      width: 25px;
      background-color: transparent;
      padding: 0;
      border: none;
      z-index: 999;

      img {
        width: 25px;
      }
    }

    .landing-block-8__video-container {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }

    .landing-block-8__testimonials-mobile {
      position: relative;

      .landing-block-8__close-video-btn {
        top: -30px;
        right: 6px;
      }
    }

    .landing-block-9 {
      padding-top: 21px;
      padding-bottom: 18px;

      @media (min-width: 768px) {
        padding-top: 25.4px;
        padding-bottom: 34px;
      }

      @media (min-width: 992px) {
        padding-top: 42px;
        padding-bottom: 35px;
      }

      @media (min-width: 1300px) {
        padding-top: 60px;
        padding-bottom: 188px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LandingMainV3.vue